import { Button, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { acceptOrder } from '../../../../../services/ApiService'
import { RequestType } from '../../../../../views/SingleRequestPage/types/Request.type'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'
import { useMarkAsDangerous } from '../../NewRequestsTable/hooks/useMarkAsDangerous'

interface ActionButtonsProps {
  request: RequestType
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ request }) => {
  const invalidate = useInvalidateQueries()
  const toDuplicate = () => newRequestDrawerStore.setMode('duplicate')
  const toImpossible = () => newRequestDrawerStore.setMode('impossible')
  const toRework = () => newRequestDrawerStore.setMode('to-rework')
  const { markAsDangerousFn, unmarkAsDangerousFn } = useMarkAsDangerous()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['accept-order-by-dealer'],
    mutationFn: () =>
      acceptOrder({
        orderId: request.id,
      }),
    onSuccess: (data) => {
      newRequestDrawerStore.updateRequest(data)
      invalidate(['requests-table'])
    },
  })

  return (
    <Stack gap={'8px'} pb={'16px'} px={'16px'}>
      {request.status === 2 && (
        <Button
          variant='contained'
          onClick={() => mutateAsync()}
          loading={isPending}
        >
          Принять
        </Button>
      )}
      {[4, 5].includes(request.status) && (
        <Button variant='outlined' onClick={toImpossible}>
          Установка невозможна
        </Button>
      )}
      {[4, 5].includes(request.status) && (
        <Button variant='outlined' onClick={toRework}>
          Вернуть на доработку
        </Button>
      )}
      {[2, 4, 5].includes(request.status) && (
        <Button variant='outlined' onClick={toDuplicate}>
          Перевести в дубликат
        </Button>
      )}
      {[2, 4, 5].includes(request.status) && !request.isDangerous && (
        <Button
          variant='outlined'
          onClick={() => markAsDangerousFn(request.id)}
        >
          включить в проблемную зону
        </Button>
      )}
      {[2, 4, 5].includes(request.status) && request.isDangerous && (
        <Button
          variant='outlined'
          onClick={() => unmarkAsDangerousFn(request.id)}
        >
          Исключить из проблемной зоны
        </Button>
      )}
    </Stack>
  )
}

export default observer(ActionButtons)
